import * as React from 'react';
import ErrorPageView from '../components/layouts/ErrorPageView';

export interface ErrorProps {
    onSubmit: () => void;
    errorTitle: string;
    errorMessage: string;
    errorBar: boolean;
    successMessage: string;
    successBar: boolean;
}

class Error extends React.Component<ErrorProps> {
    render() {
        return (
            <ErrorPageView />
        );
    }
    componentWillMount() {
        // console.log("Test");
    }
}

export default Error;



// WEBPACK FOOTER //
// ./src/error/Error.tsx